import { action } from "typesafe-actions";
import { PlaidInfo, TrustlyInfo } from "types";
export const PROVIDER_INFO = "PROVIDER_INFO";

export const setProviderInfo = (payload: PlaidInfo | TrustlyInfo) =>
  action(PROVIDER_INFO, payload);
